import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import SidebarIcon from './SidebarIcon';
import './AdminLayout.css';

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  const isSuperAdmin = (user?.role || '').toLowerCase() === 'superadmin';

  return (
    <div className={`admin-layout ${collapsed ? 'sidebar-collapsed' : ''}`}>
      {/* Top Header — BT Purple */}
      <header className="admin-topbar">
        <div className="topbar-left">
          <div className="topbar-brand">
            <img src={`${process.env.PUBLIC_URL}/quantum-forge-logo.svg`} alt="Quantum Forge" className="topbar-logo" />
            <div className="topbar-brand-text">
              <span className="topbar-title">Quantum Forge</span>
              <span className="topbar-tagline">AI based comms coach portal</span>
            </div>
          </div>
        </div>
        <div className="topbar-center">
          <img src={`${process.env.PUBLIC_URL}/bt-logo.svg`} alt="BT Group" className="topbar-bt-logo" />
        </div>
        <div className="topbar-right">
          <span className="topbar-welcome">{user?.full_name}</span>
          <button className="topbar-logout" onClick={logout}>Logout</button>
        </div>
      </header>

      {/* Sidebar — Radar style with collapse chevron inside */}
      <aside className="admin-sidebar">
        <button
          className="sidebar-collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            style={{ transition: 'transform 0.2s', transform: collapsed ? 'rotate(180deg)' : 'rotate(0)' }}>
            <polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/>
          </svg>
        </button>

        <nav className="sidebar-nav">
          <NavLink to="/admin/dashboard" data-label="Dashboard" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <SidebarIcon name="dashboard" size={18} />
            {!collapsed && <span>Dashboard</span>}
          </NavLink>
          {isSuperAdmin && (
            <NavLink to="/admin/users" data-label="Admin Management" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <SidebarIcon name="users" size={18} />
              {!collapsed && <span>Admin Management</span>}
            </NavLink>
          )}
          <NavLink to="/admin/candidates" data-label="Candidate Management" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <SidebarIcon name="candidates" size={18} />
            {!collapsed && <span>Candidate Management</span>}
          </NavLink>
          {isSuperAdmin && (
            <NavLink to="/sadmin/scenarios" data-label="Scenario Management" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <SidebarIcon name="questions" size={18} />
              {!collapsed && <span>Scenario Management</span>}
            </NavLink>
          )}
          <NavLink to="/admin/evaluation" data-label="Candidate Evaluation" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <SidebarIcon name="evaluation" size={18} />
            {!collapsed && <span>Candidate Evaluation</span>}
          </NavLink>
          <NavLink to="/admin/about" data-label="About" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <SidebarIcon name="about" size={18} />
            {!collapsed && <span>About</span>}
          </NavLink>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        {children}
      </main>
    </div>
  );
}
